import {NgModule} from '@angular/core';
import {SharedLibsModule} from './shared-libs.module';
import {RouterModule} from '@angular/router';
import {NumberCpCustomComponent} from './components/number-cp-custom/number-cp-custom.component';
import {RadioCpCustomComponent} from './components/radio-cp-custom/radio-cp-custom.component';
import {CheckboxCpCustomComponent} from './components/checkbox-cp-custom/checkbox-cp-custom.component';
import {SkillCpCustomComponent} from './components/skill-cp-custom/skill-cp-custom.component';
import {CombinationRuleComponent} from './components/combination-rule/combination-rule.component';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {MonthsToYearsPipe} from './pipes/months-to-years.pipe';
import {NouisliderModule} from 'ng2-nouislider';
import {QuillModule} from 'ngx-quill';
import {toolbarOptions} from './const/mock-selectize-config';
import {FormatDatePipe} from './pipes/format-date.pipe';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {IsJobSeekerDirective} from './directives/is-job-seeker.directive';
import {IsEmployerDirective} from './directives/is-employer.directive';
import {NumberOnlyDirective} from './directives/numberonly.directive';
import {CompanyNumFormatDirective} from './directives/company-num-format.directive';
import {DropdownDirective} from './directives/dropdown.directive';
import {AutofocusDirective} from './directives/autofocus.directive';
import {PaginationModule} from 'ngx-bootstrap/pagination';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {AuthInterceptor} from './interceptor/auth.interceptor';
import {AngularDateHttpInterceptor} from './interceptor/date-http.interceptor';
import {LoadingComponent} from './components/loading/loading.component';
import {CheckoutFormComponent} from './components/checkout-form/checkout-form.component';
import {IsAdministratorDirective} from './directives/is-administrator.directive';
import {SpecificNumberNgFor} from './pipes/ngFor-number.pipe';
import {RemoveHTMLTagPipePipe} from './pipes/removeHTMLtag.pipe';
import {ToastrModule} from 'ngx-toastr';
import {BsModalRef, ModalModule} from 'ngx-bootstrap/modal';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {ScrollToModule} from 'ng2-scroll-to-el';

@NgModule({
  imports: [
    AngularSvgIconModule.forRoot(),
    TabsModule.forRoot(),
    PaginationModule.forRoot(),
    ToastrModule.forRoot(),
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ScrollToModule.forRoot(),
    QuillModule.forRoot({
      modules: {
        syntax: false,
        toolbar: toolbarOptions
      }
    }),
    SharedLibsModule,
    RouterModule,
    NouisliderModule,
  ],
  exports: [
    SharedLibsModule,
    NumberCpCustomComponent,
    RadioCpCustomComponent,
    CheckboxCpCustomComponent,
    CheckoutFormComponent,
    SkillCpCustomComponent,
    CombinationRuleComponent,
    LoadingComponent,
    AngularSvgIconModule,
    TabsModule,
    PaginationModule,
    QuillModule,
    ToastrModule,
    ModalModule,
    BsDropdownModule,
    BsDatepickerModule,
    ScrollToModule,
    MonthsToYearsPipe,
    FormatDatePipe,
    RemoveHTMLTagPipePipe,
    SpecificNumberNgFor,
    IsJobSeekerDirective,
    IsEmployerDirective,
    NumberOnlyDirective,
    CompanyNumFormatDirective,
    DropdownDirective,
    AutofocusDirective,
    IsAdministratorDirective
  ],
  declarations: [
    NumberCpCustomComponent,
    RadioCpCustomComponent,
    CheckboxCpCustomComponent,
    CheckoutFormComponent,
    SkillCpCustomComponent,
    CombinationRuleComponent,
    LoadingComponent,
    MonthsToYearsPipe,
    FormatDatePipe,
    RemoveHTMLTagPipePipe,
    SpecificNumberNgFor,
    IsJobSeekerDirective,
    IsEmployerDirective,
    NumberOnlyDirective,
    CompanyNumFormatDirective,
    DropdownDirective,
    AutofocusDirective,
    IsAdministratorDirective
  ],
  providers: [
    BsModalRef,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AngularDateHttpInterceptor,
      multi: true
    }
  ]
})

export class SharedModule {}
